import React from "react";
import { observer } from "mobx-react";
import Stores from "../../stores/Stores";
import UIStore from "../../stores/UIStore";
import SearchField from "../../components/SearchField";
import Table from "../../components/Table";
import Panel from "../../components/Panel";
import moment from "moment";


const store = Stores.load("recent-activities");

class RecentActivities extends React.Component {
  componentDidMount() {
    UIStore.init("Atividades Recentes", store);
  }

  handleFilter = () => {
    store.page = 0;
    store.query();
  };

  render() {
    return (
      <>
        <Panel 
          title="Atividades Recentes" 
          rightPanel={
            <>
              <SearchField store={store} />
            </>
          }  
        >
          <Table
            disableSort={true}
            store={store}
            data={store.list}
            columns={[ 
              { label: "ID", field: "id" }, 
              { label: "Cervejaria", field: "breweryName" }, 
              { label: "Nome da Produção", field: "brewName" }, 
              { label: "TQ", field: "tankName" }, 
              { label: "Momento", field: "phaseTitle" }, 
              { label: "Última Atualização", field: "updatedDate", func: (v) => moment(v).format("DD/MM/YYYY HH:mm:ss") }, 
            ]}
            
          />
        </Panel>
      </>
    );
  }
}

export default observer(RecentActivities);
